(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["search"]) return;
  try {
    
(function () {
  var wrap = document.querySelector('[data-nb-search-wrap]');
  if (!wrap) return;

  var form = wrap.querySelector('[data-nb-search-form]');
  var input = wrap.querySelector('[data-nb-search-input]');
  var suggestBox = wrap.querySelector('[data-nb-search-suggest]');
  var moneyFormat = window.nbShopMoneyFormat || ('{' + '{ amount }' + '}');
  var controller = null;
  var debounceTimer = null;
  var activeIndex = -1;

  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = precision == null ? 2 : precision;
    thousands = thousands == null ? ',' : thousands;
    decimal = decimal == null ? '.' : decimal;
    if (isNaN(number) || number == null) return 0;
    number = (number / 100.0).toFixed(precision);
    var parts = number.split('.');
    var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    var cents = parts[1] ? decimal + parts[1] : '';
    return dollars + cents;
  }

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var match = format.match(placeholderRegex);
    var value = '';
    switch (match ? match[1] : 'amount') {
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }
    return match ? format.replace(placeholderRegex, value) : value;
  }

  function resizeImage(url, size) {
    if (!url) return '';
    return url.indexOf('?') > -1 ? url.replace('?', '?width=' + size + '&') : url + '?width=' + size;
  }

  function closeSuggest() {
    suggestBox.hidden = true;
    suggestBox.innerHTML = '';
    input.setAttribute('aria-expanded', 'false');
    activeIndex = -1;
  }

  function renderResults(products, term) {
    activeIndex = -1;
    if (!products.length) {
      suggestBox.innerHTML = '<p class="nb-search__suggest-empty">No products found for "' + escapeHtml(term) + '".</p>';
      suggestBox.hidden = false;
      input.setAttribute('aria-expanded', 'true');
      return;
    }

    var html = '<ul class="nb-search__suggest-list" role="listbox">';
    products.forEach(function (p) {
      var img = (p.featured_image && p.featured_image.url) || p.image || (p.images && p.images[0]) || '';
      html += '<li role="option"><a href="' + p.url + '" class="nb-search__suggest-item" data-nb-suggest-item>' +
        (img ? '<img src="' + resizeImage(img, 88) + '" alt="" width="44" height="44" loading="lazy">' : '') +
        '<span class="nb-search__suggest-info">' +
        '<span class="nb-search__suggest-title">' + escapeHtml(p.title) + '</span>' +
        '<span class="nb-search__suggest-price">' + formatMoney(p.price, moneyFormat) + '</span>' +
        '</span></a></li>';
    });
    html += '</ul><a class="nb-search__suggest-viewall" href="' + form.action + '?q=' + encodeURIComponent(term) + '&type=product">View all results for &ldquo;' + escapeHtml(term) + '&rdquo; &rarr;</a>';

    suggestBox.innerHTML = html;
    suggestBox.hidden = false;
    input.setAttribute('aria-expanded', 'true');
  }

  function fetchSuggestions(term) {
    if (controller) controller.abort();
    controller = new AbortController();
    fetch('/search/suggest.json?q=' + encodeURIComponent(term) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last', { signal: controller.signal })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var products = (data.resources && data.resources.results && data.resources.results.products) || [];
        renderResults(products, term);
      })
      .catch(function (err) {
        if (err.name !== 'AbortError') closeSuggest();
      });
  }

  input.addEventListener('input', function () {
    var term = input.value.trim();
    clearTimeout(debounceTimer);
    if (term.length < 2) {
      closeSuggest();
      return;
    }
    debounceTimer = setTimeout(function () { fetchSuggestions(term); }, 250);
  });

  input.addEventListener('focus', function () {
    if (input.value.trim().length >= 2 && suggestBox.innerHTML) suggestBox.hidden = false;
  });

  input.addEventListener('keydown', function (e) {
    var items = suggestBox.querySelectorAll('[data-nb-suggest-item]');
    if (e.key === 'Escape') {
      closeSuggest();
      return;
    }
    if (!items.length) return;
    if (e.key === 'ArrowDown') {
      e.preventDefault();
      activeIndex = Math.min(activeIndex + 1, items.length - 1);
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      activeIndex = Math.max(activeIndex - 1, -1);
    } else if (e.key === 'Enter' && activeIndex > -1) {
      e.preventDefault();
      items[activeIndex].click();
      return;
    } else {
      return;
    }
    items.forEach(function (item, i) { item.classList.toggle('is-active', i === activeIndex); });
    if (activeIndex > -1) items[activeIndex].scrollIntoView({ block: 'nearest' });
  });

  document.addEventListener('click', function (e) {
    if (!wrap.contains(e.target)) closeSuggest();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
